export const sports = [
  {
    sportId: 1,
    label: "Basketball",
    slug: "basketball",
  },
  {
    sportId: 2,
    label: "Hockey",
    slug: "hockey",
  },
  {
    sportId: 3,
    label: "Baseball",
    slug: "baseball",
  },
  {
    sportId: 4,
    label: "Golf",
    slug: "golf",
  },
  {
    sportId: 5,
    label: "Soccer",
    slug: "soccer",
  },
  {
    sportId: 6,
    label: "Tennis",
    slug: "tennis",
  },
  {
    sportId: 7,
    label: "MMA",
    slug: "mma",
  },
  {
    sportId: 8,
    label: "Football",
    slug: "american-football",
  },
  {
    sportId: 9,
    label: "E Sports",
    slug: "e-sports",
  },
  {
    sportId: 10,
    label: "Novelty Markets",
    slug: "novelty-markets",
  },
  {
    sportId: 11,
    label: "Rugby Union",
    slug: "rugby-union",
  },
  {
    sportId: 12,
    label: "Racing",
    slug: "racing",
  },
  {
    sportId: 13,
    label: "Boxing",
    slug: "boxing",
  },
  {
    sportId: 14,
    label: "Crypto",
    slug: "crypto",
  },
  {
    sportId: 15,
    label: "Cricket",
    slug: "cricket",
  },
  {
    sportId: 16,
    label: "Economics",
    slug: "economics",
  },
  {
    sportId: 17,
    label: "Politics",
    slug: "politics",
  },
  {
    sportId: 18,
    label: "Entertainment",
    slug: "entertainment",
  },
  {
    sportId: 19,
    label: "Medicinal",
    slug: "medicinal",
  },
  {
    sportId: 20,
    label: "Rugby League",
    slug: "rugby-league",
  },
  {
    sportId: 21,
    label: "Olympics",
    slug: "olympics",
  },
  {
    sportId: 22,
    label: "Athletics",
    slug: "athletics",
  },
  {
    sportId: 23,
    label: "NFTs",
    slug: "nfts",
  },
  {
    sportId: 24,
    label: "Horse Racing",
    slug: "horse-racing",
  },
  {
    sportId: 25,
    label: "Daily Parlays",
    slug: "daily-parlays",
  },
  {
    sportId: 27,
    label: "Degen Crypto",
    slug: "degen-crypto",
  },
  {
    sportId: 28,
    label: "InplayLIVE",
    slug: "inplaylive",
  },
  {
    sportId: 29,
    label: "Sailing",
    slug: "sailing",
  },
  {
    sportId: 26,
    label: "AFL",
    slug: "afl",
  },
]
